import { useSelector } from 'react-redux';
import { RootState } from "../../redux/reducers";
import { useNavigate } from "react-router-dom";
import {
    Box, Rating, Container, Typography,
    Table, TableRow, TableCell, Grid,
    TableBody,
    Grid2
} from "@mui/material";
import { useStyles } from "../../screens/ProductList/ProductList";
import Footer from '../../components/footer/footer';
import Header from '../../components/header/header';

const HEIGHT = window.innerHeight;

const ProductComparePage = () => {
    const styles = useStyles();
    const history = useNavigate();
    const selectedProductIds = useSelector((state: RootState) => state.productComparison.productIdsToCompare);

    const compareLabel = Array.from(
        new Map(
            selectedProductIds.flatMap(product =>
                product?.productSpecifications?.filter(spec => spec?.specificationLabelName)
            ).map(spec => [spec.specificationLabelName, spec])
        ).values()
    );

    return (
        <>
            <Header />
            <Container disableGutters={false} maxWidth={false} sx={{ maxWidth: '1400px', minWidth: '1000px', marginTop: '105px' }}>
                <Box>
                    <Box sx={{ fontSize: '24px', fontWeight: 'bold', color: '#c72a22' }}>
                        <label>Compare Products</label>
                    </Box>

                    <Table sx={{ borderCollapse: "collapse", width: "100%" }}>
                        <TableBody>
                            <TableRow>
                                {/* Label Column (empty to align with spec labels below) */}
                                <TableCell sx={{ width: '16.66%' }}></TableCell>

                                {/* Product Cells */}
                                {selectedProductIds.map((product, index) => (
                                    <TableCell
                                        key={index}
                                        sx={{
                                            width: `${100 / (selectedProductIds.length + 1)}%`,
                                            verticalAlign: 'top',
                                            px: 2,
                                        }}
                                    >
                                        <Box onClick={() => history("/productdetail", { state: product.productId })} sx={{ cursor: 'pointer' }}>
                                            <Box
                                                sx={{
                                                    height: (HEIGHT / 100) * 18,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    mt: 1,
                                                    mb: 1,
                                                }}
                                            >
                                                <Box
                                                    component="img"
                                                    src={product.productImageUrl}
                                                    sx={{ width: '80%', height: (HEIGHT * 18) / 100, objectFit: 'contain' }}
                                                />
                                            </Box>
                                            <label className={styles.bestText1}><strong>{product.category.categoryName}</strong></label>

                                            <Box>
                                                <label className={styles.bestText}>
                                                    <strong> {product.displayName || "Default Product Name"}</strong>
                                                </label>
                                            </Box>

                                            <Box>
                                                <label className={styles.bestText1}>
                                                    {product.model || "Default Model"}
                                                </label>
                                            </Box>

                                            <Box>
                                                <label className={styles.orgText}><strong>${product.salePrice ?? 0}</strong></label>
                                                <label className={product.productDiscount ? styles.crsText : styles.crsTextNormal}>
                                                    <strong> ${product.mrpPrice ?? 0}</strong>
                                                </label>

                                                <Grid2 size={5} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                                    <Box sx={{ '& .MuiRating-icon': { fontSize: 15 } }}>
                                                        <Rating value={product.averageRating ? product.averageRating : 0} readOnly precision={0.5} size={'small'} />
                                                    </Box>
                                                    <Box style={{ flexDirection: "row", alignItems: "center", marginLeft: '2px', marginBottom: '8px' }}>
                                                        <label className={styles.starCount}><strong>({product.totalRatings})</strong></label>
                                                    </Box>
                                                </Grid2>
                                            </Box>
                                        </Box>
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableBody>
                    </Table>


                    <Box sx={{ mt: 4 }}>
                        {selectedProductIds?.length > 0 ? (
                            <Table sx={{ borderCollapse: "collapse" }}>
                                <TableBody>
                                    {compareLabel.map((item: any, rowIndex: number) => (
                                        <TableRow key={rowIndex}>
                                            {/* Label column */}
                                            <TableCell
                                                sx={{
                                                    width: '16.66%',
                                                    verticalAlign: 'top',
                                                    py: 1.5,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: '#c72a22',
                                                        fontWeight: 'bold',
                                                        fontSize: '1.2rem',
                                                        lineHeight: 1.4,
                                                    }}
                                                >
                                                    {item.specificationLabelName}
                                                </Typography>
                                            </TableCell>

                                            {/* Each product's spec value */}
                                            {selectedProductIds.map((product, colIndex) => {
                                                const spec = product.productSpecifications.find(
                                                    s => s.specificationLabelName === item.specificationLabelName
                                                );

                                                return (
                                                    <TableCell
                                                        key={colIndex}
                                                        sx={{
                                                            width: `${83.34 / selectedProductIds.length}%`,
                                                            verticalAlign: 'top',
                                                            py: 1.5,
                                                        }}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                color: '#0a3150',
                                                                fontWeight: 'bold',
                                                                fontSize: '0.95rem',
                                                                lineHeight: 1.4,
                                                            }}
                                                        >
                                                            {spec?.specificationLabelText || '-'}
                                                        </Typography>
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        ) : (
                            <Typography variant="body2" color="textSecondary">
                                No technical specifications available.
                            </Typography>
                        )}
                    </Box>

                </Box>
            </Container >
            <Footer />
        </>
    );
};

export default ProductComparePage;
